module.exports = __webpack_public_path__ + "img/meet-our-team.e36a55b8.png";